import ReceptionMobileList from '@/components/ReceptionMobile/ReceptionMobileList'
import WarehouseTransferMobileDetail from '@/components/ReceptionMobile/WarehouseTransferMobileDetail'

// Entrée unique du pad : retours clients + transferts inter-entrepôts entrants.
let ReceptionMobileRouter = [{
    path: '/reception_mobile',
    name: 'ReceptionMobileList',
    component: ReceptionMobileList,
    meta: {
      title: 'Réceptions',
      requiresAuth: true,
      authorizations: ['business-return_index', 'mobile_access']
    }
  },
  {
    path: '/reception_mobile/warehouse-transfer/:id',
    name: 'WarehouseTransferMobileDetail',
    component: WarehouseTransferMobileDetail,
    meta: {
      title: 'Fiche transfert inter-entrepôts',
      requiresAuth: true,
      authorizations: ['business-return_index', 'mobile_access']
    }
  }
]

export default ReceptionMobileRouter



// WEBPACK FOOTER //
// ./src/components/ReceptionMobile/router.js